export interface IApiPlaceResponse {
  place_id?: string;
  description?: string;
  structured_formatting?: {
    main_text?: string;
  };
  types?: string[];
  LocationID?: string; // For RHP location response
  Distance?: number;
  Text?: string;
  Type?: string;
  Lat?: number;
  Lon?: number;
}

export default class Place {
  placeId: string;
  description: string;
  mainText: string;
  lat: number;
  lng: number;
  countryName: string;
  types: string[];
  type?: string;
  distance?: number;

  constructor() {
    this.placeId = '';
    this.description = '';
    this.mainText = '';
    this.lat = 0;
    this.lng = 0;
    this.countryName = '';
    this.types = [];
  }

  static mappingObject(_place: IApiPlaceResponse): Place {
    const place = new Place();
    place.placeId = _place.place_id ? _place.place_id : '';
    place.description = _place.description ? _place.description : '';
    place.mainText = _place.structured_formatting && _place.structured_formatting.main_text ? _place.structured_formatting.main_text : '';
    place.type = _place.types && _place.types[0] ? _place.types[0] : '';
    place.types = _place.types || [];
    //  place.scountryName =_place.terms && _place.terms.length > 0 ? _place.terms[2].value : "";
    return place;
  }

  static mappingObjects(_places: IApiPlaceResponse[]): Place[] {
    const places: Place[] = [];
    _places.forEach(_place => {
      const place = Place.mappingObject(_place);
      places.push(place);
    });
    return places;
  }

  static mappingRHPLocation(_place: IApiPlaceResponse): Place {
    const place = new Place();
    place.placeId = _place.LocationID ? _place.LocationID : '';
    place.distance = _place.Distance;
    place.description = _place && _place.Text ? _place.Text : '';
    place.type = _place && _place.Type ? _place.Type : '';
    place.lat = _place.Lat || 0;
    place.lng = _place.Lon || 0;
    //  place.countryName =_place.terms && _place.terms.length > 0 ? _place.terms[2].value : "";
    return place;
  }

  static mappingRHPLocations(_places: IApiPlaceResponse[]): Place[] {
    const places: Place[] = [];
    _places.forEach(_place => {
      const place = Place.mappingRHPLocation(_place);
      places.push(place);
    });
    return places;
  }
}
